// extracted by mini-css-extract-plugin
module.exports = {"pickup-address":"_2912y","pickupAddress":"_2912y"};